import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { getAllShopList, getAllSubscriptionList } from "../../restApi/api";
import moment from "moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { decrypt } from "../../utils/crypto";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import { GET_Subscription_Order } from "../../gql/queries";
import { useQuery } from "@apollo/client";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import NoDataFound from "../common/NoDataFound/NoDataFound";
import ConnectionError from "../common/NoDataFound/ConnectionError";



export default function MyOrder() {
	let navigate = useNavigate()
	const location = useLocation();
	const [tab, setTab] = useState('subscription')
	let [loader, setloader] = useState(true)
	const [subscription, setSubscription] = useState(null);
	const [shops, setShop] = useState(null);


	const query1 = useQuery(GET_Subscription_Order, {
		variables: {
			"perPage": 100,
			"page": 1,
			"purchaseType": "SUBSCRIPTION"
		},
	});
	// console.log(query1.data, "query 1 data");
	const query2 = useQuery(GET_Subscription_Order, {
		variables: {
			"perPage": 100,
			"page": 1,
			"purchaseType": "SHOP"
		},
	});

	// const getallsubscriptionlist=async ()=>{
	//     await getAllSubscriptionList()
	//     .then(response => {
	//       return response.json()
	//     })
	//     .then(data => {
	// 		let req= JSON.parse(decrypt(data))
	// 		if(req.data.code===1){
	// 			setloader(false)
	// 			setSubscription(req)
	// 		}
	// 		else if(req.data.code==402){
	// 			setloader(false)
	// 			authorizationCheck(navigate)
	// 		 }
	//     }).catch((err)=>{
	// 		setloader(false)
	// 	})
	// }

	// const shop = async () => {
	// 	setloader(true)
	// 	 getAllShopList()
	//     .then(response => {
	//       return response.json()
	//     })
	// 		.then(data => {
	// 				setloader(false)
	// 		let req= JSON.parse(decrypt(data))
	// 		if(req.data.code===1){
	// 			setShop(req)
	// 		}
	// 		else if(req.data.code==402){
	// 			authorizationCheck(navigate)
	// 		 }
	// 		}).catch((error) => {
	// 				setloader(false)
	// 			})
	// }

	useEffect(() => {
		// getallsubscriptionlist()
		// shop()
		query1.refetch();
		query2.refetch();
	}, []);

	if (query1?.loading || query2?.loading) return (<><Loader /></>)
	if (query1?.error || query2?.error) {
		if (query1?.error?.graphQLErrors.some((e) => e?.extensions?.code === 'UNAUTHENTICATED') || query2?.error?.graphQLErrors.some((e) => e?.extensions?.code === 'UNAUTHENTICATED')) {
			//   history.push('/login');
			authorizationCheck(navigate)

		}
		else if (query1?.error?.graphQLErrors.some((e) => e?.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
			return (<>
				<div className="main_wrapper">
					<div className="col-lg-12">
						<SomethingWentWrong pathName={location.pathname} />
					</div>
				</div>
			</>)
		}
		else {
			return (<>
				<div className="main_wrapper">
					<div className="col-lg-12">
						<ConnectionError pathName={location.pathname} />
					</div>
				</div>
			</>)

		}
	}



	// const finalAmount = (data) => {
	// 	if (data?.isAssignedPackageByAdmin !== true) {
	// 		if (data?.boughtWithVibe == true && data?.boughtWithNotes == false) {
	// 			let paid_amount = 0
	// 			let coupon_amount = 0
	// 			if (data.priceAfterCoupon) {
	// 				paid_amount = data.priceAfterCoupon
	// 			} else {
	// 				paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
	// 				coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
	// 			}
	// 			// let pendrive_paid_amount = data.planPurchased&& data.planPurchased.vibe?.penDrivePaidAmount ? data.planPurchased.vibe?.penDrivePaidAmount : 0
	// 			// let pendrive_coupon_amount = data.planPurchased&&data.planPurchased.vibe?.penDriveCouponDiscount ? data.planPurchased.vibe.penDriveCouponDiscount : 0;
	// 			if (data?.planPurchased?.vibe !== null) {
	// 				var pendrive_paid_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0
	// 				var pendrive_coupon_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDriveCouponDiscount ? data?.planPurchased?.vibe?.penDriveCouponDiscount : 0;
	// 			}
	// 			else {
	// 				var pendrive_paid_amount = 0
	// 				var pendrive_coupon_amount = 0
	// 			}

	// 			let final_amount = (paid_amount + pendrive_paid_amount) - (coupon_amount + pendrive_coupon_amount)
	// 			return final_amount.toFixed(2);
	// 		}
	// 		else if (data?.boughtWithNotes == true && data?.boughtWithVibe == false) {
	// 			let paid_amount = 0
	// 			let coupon_amount = 0
	// 			if (data.priceAfterCoupon) {
	// 				paid_amount = data.priceAfterCoupon
	// 			} else {
	// 				paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
	// 				coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
	// 			}
	// 			// let notes_paid_amount =data.planPurchased&& data.planPurchased.notes?.notesPaidAmount ? data.planPurchased.notes.notesPaidAmount : 0;
	// 			// let notes_coupon_amount = data.planPurchased&& data.planPurchased.notes?.notesCouponDiscount ? data.planPurchased.notes.notesCouponDiscount : 0
	// 			if (data?.planPurchased?.notes !== null) {
	// 				var notes_paid_amount = data?.planPurchased && data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0;
	// 				var notes_coupon_amount = data?.planPurchased && data?.planPurchased?.notes?.notesCouponDiscount ? data?.planPurchased?.notes?.notesCouponDiscount : 0
	// 			}
	// 			else {
	// 				var notes_paid_amount = 0
	// 				var notes_coupon_amount = 0
	// 			}
	// 			let final_amount = (paid_amount + notes_paid_amount) - (coupon_amount + notes_coupon_amount)
	// 			return final_amount.toFixed(2);
	// 		}
	// 		else if (data?.boughtWithNotes == false && data?.boughtWithVibe == false) {
	// 			let paid_amount = 0
	// 			let coupon_amount = 0
	// 			if (data.priceAfterCoupon) {
	// 				paid_amount = data.priceAfterCoupon
	// 			} else {
	// 				paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
	// 				coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
	// 			}
	// 			if (data?.planPurchased?.notes !== null) {
	// 				var notes_paid_amount = data?.planPurchased && data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0;
	// 				var notes_coupon_amount = data?.planPurchased && data?.planPurchased?.notes?.notesCouponDiscount ? data?.planPurchased?.notes?.notesCouponDiscount : 0
	// 			}
	// 			else {
	// 				var notes_paid_amount = 0
	// 				var notes_coupon_amount = 0
	// 			}
	// 			if (data?.planPurchased?.vibe !== null) {
	// 				var pendrive_paid_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0
	// 				var pendrive_coupon_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDriveCouponDiscount ? data?.planPurchased?.vibe?.penDriveCouponDiscount : 0;
	// 			}
	// 			else {
	// 				var pendrive_paid_amount = 0
	// 				var pendrive_coupon_amount = 0
	// 			}
	// 			let final_amount = (paid_amount + notes_paid_amount + pendrive_paid_amount) - (coupon_amount + notes_coupon_amount + pendrive_coupon_amount)
	// 			return final_amount.toFixed(2);
	// 		}
	// 		else {
	// 			let paid_amount = 0
	// 			let coupon_amount = 0
	// 			if (data.priceAfterCoupon) {
	// 				paid_amount = data.priceAfterCoupon
	// 			} else {
	// 				paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
	// 				coupon_amount = data?.couponDiscount ? data?.couponDiscount : 0;
	// 			}
	// 			if (data?.planPurchased?.notes !== null) {
	// 				var notes_paid_amount = data?.planPurchased && data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0;
	// 				var notes_coupon_amount = data?.planPurchased && data?.planPurchased?.notes?.notesCouponDiscount != 0 ? data?.planPurchased?.notes?.notesCouponDiscount : 0
	// 			}
	// 			else {
	// 				var notes_paid_amount = 0
	// 				var notes_coupon_amount = 0
	// 			}
	// 			if (data?.planPurchased?.vibe !== null) {
	// 				var pendrive_paid_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0
	// 				var pendrive_coupon_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDriveCouponDiscount != 0 ? data?.planPurchased?.vibe?.penDriveCouponDiscount : 0;
	// 			}
	// 			else {
	// 				var pendrive_paid_amount = 0
	// 				var pendrive_coupon_amount = 0
	// 			}
	// 			let final_amount = (paid_amount + notes_paid_amount + pendrive_paid_amount) - (coupon_amount)
	// 			return final_amount.toFixed(2);
	// 		}
	// 	}
	// 	else {
	// 		let final_amount = 0
	// 		return final_amount.toFixed(2);
	// 	}
	// }
	function finalAmount(data) {
		if (data?.isAssignedPackageByAdmin !== true) {
			if (data?.boughtWithVibe === true && data?.boughtWithNotes === false) {
				let paid_amount = 0;
				let coupon_amount = 0;
				if (data.priceAfterCoupon) {
					paid_amount = data.priceAfterCoupon;
				} else {
					paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
					coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
				}
				let pendrive_paid_amount = data?.planPurchased?.vibe !== null ? (data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0) : 0;
				let pendrive_coupon_amount = data?.planPurchased?.vibe !== null ? (data?.planPurchased?.vibe?.penDriveCouponDiscount || 0) : 0;

				let final_amount = (paid_amount + pendrive_paid_amount) - (coupon_amount + pendrive_coupon_amount);
				return final_amount.toFixed(2);
			} else if (data?.boughtWithNotes === true && data?.boughtWithVibe === false) {
				let paid_amount = 0;
				let coupon_amount = 0;
				if (data.priceAfterCoupon) {
					paid_amount = data.priceAfterCoupon;
				} else {
					paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
					coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
				}
				let notes_paid_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0) : 0;
				let notes_coupon_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesCouponDiscount || 0) : 0;

				let final_amount = (paid_amount + notes_paid_amount) - (coupon_amount + notes_coupon_amount);
				return final_amount.toFixed(2);
			} else if (data?.boughtWithNotes === false && data?.boughtWithVibe === false) {
				let paid_amount = 0;
				let coupon_amount = 0;
				if (data.priceAfterCoupon) {
					paid_amount = data.priceAfterCoupon;
				} else {
					paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
					coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
				}
				let notes_paid_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0) : 0;
				let notes_coupon_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesCouponDiscount || 0) : 0;
				let pendrive_paid_amount = data?.planPurchased?.vibe !== null ? (data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0) : 0;
				let pendrive_coupon_amount = data?.planPurchased?.vibe !== null ? (data?.planPurchased?.vibe?.penDriveCouponDiscount || 0) : 0;

				let final_amount = (paid_amount + notes_paid_amount + pendrive_paid_amount) - (coupon_amount + notes_coupon_amount + pendrive_coupon_amount);
				return final_amount.toFixed(2);
			} else {
				let paid_amount = 0;
				let coupon_amount = 0;
				if (data.priceAfterCoupon) {
					paid_amount = data.priceAfterCoupon;
				} else {
					paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
					coupon_amount = data?.couponDiscount ? data?.couponDiscount : 0;
				}
				let notes_paid_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0) : 0;
				let notes_coupon_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesCouponDiscount || 0) : 0;
				let pendrive_paid_amount = data?.planPurchased?.vibe !== null ? (data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0) : 0;

				let final_amount = (paid_amount + notes_paid_amount + pendrive_paid_amount) - (coupon_amount);
				return final_amount.toFixed(2);
			}
		} else {
			return "0.00";
		}
	}

	const naviTab = (data) => {
		setTab(data)
	}


	// console.log(query1.data, "query 1 data is fetching");
	return (
		<>
			{
				<div className="main_wrapper">
					<div className="breadcrumbs">
						<ul className="breadcrumb">
							<li className="breadcrumb-item"><a >Home</a></li>
							<li className="breadcrumb-item"><a >Account</a></li>
							<li className="breadcrumb-item active"><a >My Order</a></li>
						</ul>
					</div>
					<section className="videoLayer_wrapper account_main_wrapper my_order_wrapper section_side_padding">
						<div className='row'>
							<div className="col-lg-8 col-md-7 col-sm-12">
								<div className="subjects_wrapper">
									<div className="setting_ttl_wrapper d-flex align-items-center">
										<figure className="sett_back_arrow">
											{
												<Link to={'/account'}>
													<img src={Icons.BackArrow} alt="" className="img-fluid" />
												</Link>
											}
										</figure>
										<div className="sett_ttl">
											<h5>My Order</h5>
										</div>
									</div>
									<div className="recommended_video_wrapper videoMainContent">
										<div className="main_tabs_wrapper">
											<div className="tabs_main_wrap">
												<div className="tabs_main">
													<ul className="nav nav-tabs">
														<li className="nav-item">
															<a className="nav-link active" data-toggle="tab" href="#subscription" onClick={(e) => naviTab('subscription')}>Subscription</a>
														</li>
														<li className="nav-item">
															<a className="nav-link" data-toggle="tab" href="#shop" onClick={(e) => naviTab('shop')} >Shop</a>
														</li>
													</ul>
												</div>
											</div>
											<div className="tab-content">

												{
													<>
														{
															tab == 'subscription' &&
															<div className="tab-pane active" id="subscription">
																<div className="recommend_video_details">
																	<ul type="none" className="recommend_list">
																		{

																			query1.data && query1.data.myOrders.orders.map((d, i) => (
																				<li>
																					<Link to={`/account/orderdetail`} state={JSON.stringify(d)}>
																						<div className="active_plan_wrapper d-flex align-items-center">
																							<div className="active_plan_content">
																								{
																									d.isAssignedPackageByAdmin === true && d.expire === false &&
																									<span className="assigned">Assigned</span>
																								}
																								{/* {
																					(d.packageType!==1)&&
																						<span className="loan_applied">Loan Applied</span>
																					} */}
																								{
																									d.expire !== false &&
																									<span className="expired">Expired</span>
																								}
																								{/* {
																									d.status == true && d.expire === false && d.transactionStatus === 'COMPLETED' && d.isAssignedPackageByAdmin !== true &&
																									<span className="active">Active</span>

																								}
																								{
																									d.status == false && d.expire === false && d.transactionStatus === 'COMPLETED' && d.isAssignedPackageByAdmin !== true &&
																									<span className="expired">Inactive</span>

																								} */}
																								{
																									(d.status == true && d.expire === false) &&
																									<span className="active">Active</span>

																								}
																								{
																									(d.status == false && d.expire === false) &&
																									<span className="expired">Inactive</span>

																								}
																								{
																									d.expire === false && d.transactionStatus === 'INITIATED' &&
																									<span className="pending">Initiated</span>

																								}
																								{
																									d.expire === false && d.transactionStatus === 'FAILED' &&
																									<span className="pending">Failed</span>

																								}
																								<h6>{d.packageDetails ? d.packageDetails.title : ""}</h6>
																								<p><span>Purchased on: </span>{d ? moment(d.buyDate).format('DD MMM YYYY') : ""}, at {d ? moment(d.buyDate).format('hh:mm a') : ""}</p>
																								<p><span>Valid till: </span>{d ? moment(d.expiryDate).format('DD MMM YYYY') : ""}</p>
																							</div>
																							<div className="active_plan_price">
																								<h6>&#8377; {finalAmount(d)}</h6>
																								<img src={Icons.OrderArrow} alt="" className="img-fluid" />
																							</div>
																						</div>
																					</Link>
																				</li>
																			))
																		}
																		{/* <li>	
																	<div className="active_plan_wrapper d-flex align-items-center">
																		<div className="active_plan_content">
																			<span className="assigned">Assigned</span>
																			<span className="loan_applied">Loan Applied</span>
																			<h6>Basic Plus</h6>
																			<p><span>Purchased on:</span>03 JAN, at 4:30PM</p>
																			<p><span>Valid till:</span>03 JAN 2023</p>
																		</div>
																		<div className="active_plan_price">
																			<h6>&#8377; 9,749</h6>
																			<img src={Icons.OrderArrow} alt="" className="img-fluid"/>
																		</div>
																	</div>
																</li>
																<li>
																	<div className="active_plan_wrapper d-flex align-items-center">
																		<div className="active_plan_content">
																			<span className="expired">Expired</span>
																			<h6>Basic Plus</h6>
																			<p><span>Purchased on:</span>03 JAN, at 4:30PM</p>
																			<p><span>Valid till:</span>03 JAN 2023</p>
																		</div>
																		<div className="active_plan_price">
																			<h6>&#8377; 9,749</h6>
																			<img src={Icons.OrderArrow} alt="" className="img-fluid"/>
																		</div>
																	</div>
																</li> */}
																	</ul>
																</div>
															</div>

														}
														{
															tab == 'subscription' && query1.data && query1.data?.myOrders?.orders?.length === 0 &&
															<NoDataFound />
														}
													</>
												}
												{
													<>
														{
															tab === 'shop' &&
															<div className="tab-pane active" id="shop">
																<div className="recommend_video_details">
																	<ul type="none" className="recommend_list">
																		{
																			query2.data && query2.data.myOrders.orders.map((d, i) => (
																				<li>
																					<Link to={`/account/orderdetail`} state={JSON.stringify(d)}>
																						<div className="active_plan_wrapper d-flex align-items-center">
																							<div className="active_plan_content">
																								{
																									d.transactionStatus === 'COMPLETED' &&
																									<span className="active">Purchased</span>
																								}
																								{
																									d.transactionStatus === 'INITIATED' &&
																									<span className="pending">Initiated</span>
																								}
																								<h6>{d.packageDetails ? d.packageDetails.title : ""}</h6>
																								<p><span>Purchased on: </span>{d ? moment(d.buyDate).format('DD MMM YYYY') : ""}, at {d ? moment(d.buyDate).format('hh:mm a') : ""}</p>
																								{/* <p><span>Valid till: </span>{d?moment(d.tillDate).format('DD MMM YYYY'):""}</p> */}
																							</div>
																							{/* {
																	d.isFromMainSubscription==true&&
																	<div className="active_plan_price">
																		<h6>As Add-on</h6>
																		<img src={Icons.OrderArrow} alt="" className="img-fluid"/>
																	</div>
																	} */}
																							{
																								<div className="active_plan_price">
																									<h6>&#8377; {d.finalAmount}</h6>
																									<img src={Icons.OrderArrow} alt="" className="img-fluid" />
																								</div>
																							}
																						</div>
																					</Link>
																				</li>
																			))
																		}
																		{/* <li>	
															<div className="active_plan_wrapper d-flex align-items-center">
																<div className="active_plan_content">
																	<span className="assigned">Assigned</span>
																	<span className="loan_applied">Loan Applied</span>
																	<h6>Basic Plus</h6>
																	<p><span>Purchased on:</span>03 JAN, at 4:30PM</p>
																	<p><span>Valid till:</span>03 JAN 2023</p>
																</div>
																<div className="active_plan_price">
																	<h6>&#8377; 9,749</h6>
																	<img src={Icons.OrderArrow} alt="" className="img-fluid"/>
																</div>
															</div>
														</li>
														<li>
															<div className="active_plan_wrapper d-flex align-items-center">
																<div className="active_plan_content">
																	<span className="expired">Expired</span>
																	<h6>Basic Plus</h6>
																	<p><span>Purchased on:</span>03 JAN, at 4:30PM</p>
																	<p><span>Valid till:</span>03 JAN 2023</p>
																</div>
																<div className="active_plan_price">
																	<h6>&#8377; 9,749</h6>
																	<img src={Icons.OrderArrow} alt="" className="img-fluid"/>
																</div>
															</div>
														</li> */}
																	</ul>
																</div>
															</div>
														}
														{
															tab === 'shop' && query2.data && query2.data?.myOrders?.orders?.length === 0 &&
															<NoDataFound />
														}
													</>
												}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
			}
		</>
	)
}